import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class DropdownsRolesIndexComponent extends Component {
  @service store;

  get roles() {
    return this.store.peekAll('role').map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }
}
